import {
    GET_TERMINAL_DEF_SUCCESS,
    TERMINAL_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
}

const terminalDef = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_TERMINAL_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }

        case TERMINAL_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default terminalDef